import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { FileText } from 'lucide-react';
import { TermsContent } from './TermsPage';

/**
 * In-app Terms & Conditions modal — opened from Help menu.
 * Reuses the same content block as the standalone /terms page.
 */
export default function TermsModal({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="bg-zinc-900 border-zinc-700 max-w-2xl max-h-[85vh] overflow-y-auto"
        data-testid="terms-modal"
      >
        <DialogHeader className="sticky top-0 z-10 bg-zinc-900 -mx-6 px-6 pt-2 pb-3 border-b border-zinc-800">
          <DialogTitle className="text-zinc-100 flex items-center gap-2 text-lg">
            <FileText className="w-5 h-5 text-cyan-400" />
            Terms &amp; Conditions
          </DialogTitle>
        </DialogHeader>
        <div className="py-2">
          <TermsContent />
        </div>
      </DialogContent>
    </Dialog>
  );
}
